import React from 'react';
import { User, Ruler, Weight, Calendar } from 'lucide-react';

const PersonalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Система измерения */}
      <div className="col-span-full mb-2">
        <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Система измерения
        </div>
        <div className="grid grid-cols-2 gap-2">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="measurementSystem"
              value="metric"
              checked={formData.measurementSystem === 'metric'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Метрическая (см, кг)
            </span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="measurementSystem"
              value="imperial"
              checked={formData.measurementSystem === 'imperial'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Имперская (дюймы, фунты)
            </span>
          </label>
        </div>
      </div>

      {/* Вес */}
      <div>
        <label htmlFor="weight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Weight className="w-4 h-4 mr-2 text-emerald-500" />
          {formData.measurementSystem === 'metric' ? 'Вес (кг)' : 'Вес (фунты)'}
        </label>
        <input
          type="text"
          id="weight"
          name="weight"
          value={formData.weight}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.weight ? 'input-error' : ''}`}
          placeholder={formData.measurementSystem === 'metric' ? 'Введите вес в кг' : 'Введите вес в фунтах'}
        />
        {errors.weight && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.weight}
          </p>
        )}
      </div>

      {/* Рост */}
      <div>
        <label htmlFor="height" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Ruler className="w-4 h-4 mr-2 text-emerald-500" />
          {formData.measurementSystem === 'metric' ? 'Рост (см)' : 'Рост (дюймы)'}
        </label>
        <input
          type="text"
          id="height"
          name="height"
          value={formData.height}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.height ? 'input-error' : ''}`}
          placeholder={formData.measurementSystem === 'metric' ? 'Введите рост в см' : 'Введите рост в дюймах'}
        />
        {errors.height && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.height}
          </p>
        )}
      </div>

      {/* Возраст */}
      <div>
        <label htmlFor="age" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-emerald-500" />
          Возраст (лет)
        </label>
        <input
          type="text"
          id="age"
          name="age"
          value={formData.age}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.age ? 'input-error' : ''}`}
          placeholder="Введите возраст"
        />
        {errors.age && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.age}
          </p>
        )}
      </div>

      {/* Пол */}
      <div>
        <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
          <User className="w-4 h-4 mr-2 text-emerald-500" />
          Пол
        </div>
        <div className="grid grid-cols-2 gap-2">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="gender"
              value="male"
              checked={formData.gender === 'male'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Мужской
            </span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="gender"
              value="female"
              checked={formData.gender === 'female'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Женский
            </span>
          </label>
        </div>
        {errors.gender && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.gender}
          </p>
        )}
      </div>

      {/* Информационная карточка */}
      <div className="col-span-full mt-2">
        <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800 text-sm text-blue-700 dark:text-blue-300">
          <p>
            <strong>Обратите внимание:</strong> Индекс массы тела - это простой способ оценить соотношение веса и роста, 
            но не учитывает состав тела (соотношение мышц и жира). Спортсмены и люди с развитой мускулатурой 
            могут иметь высокий ИМТ при нормальном количестве жира в организме.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PersonalParametersSection;